"use strict";
/**
 * {@code SteeringAcceleration} is a movement requested by the steering system. It is made up of two components, linear and angular
 * acceleration.
 *
 * @param <T> Type of vector, either 2D or 3D, implementing the {@link Vector} interface
 *
 * @author davebaol
 */
var SteeringAcceleration = (function () {
    /**
     * Creates a {@code SteeringAcceleration} with the given linear and angular components.
     *
     * @param linear The initial linear acceleration to give this SteeringAcceleration.
     * @param angular The initial angular acceleration to give this SteeringAcceleration.
     */
    function SteeringAcceleration(linear, angular) {
        if (angular === void 0) { angular = 0; }
        if (linear == null)
            throw new Error('Linear acceleration cannot be null');
        this.linear = linear;
        this.angular = angular;
    }
    /** Returns {@code true} if both linear and angular components of this steering acceleration are zero; {@code false} otherwise. */
    SteeringAcceleration.prototype.isZero = function () {
        return this.angular === 0 && this.linear.isZero();
    };
    /**
     * Zeros the linear and angular components of this steering acceleration.
     * @return this steering acceleration for chaining
     */
    SteeringAcceleration.prototype.setZero = function () {
        this.linear.setZero();
        this.angular = 0;
        return this;
    };
    /**
     * Adds the given steering acceleration to this steering acceleration.
     *
     * @param steering the steering acceleration
     * @return this steering acceleration for chaining
     */
    SteeringAcceleration.prototype.add = function (steering) {
        this.linear.add(steering.linear);
        this.angular += steering.angular;
        return this;
    };
    /**
     * Scales this steering acceleration by the specified scalar.
     *
     * @param scalar the scalar
     * @return this steering acceleration for chaining
     */
    SteeringAcceleration.prototype.scl = function (scalar) {
        this.linear.scale(scalar);
        this.angular *= scalar;
        return this;
    };
    /**
     * First scale a supplied steering acceleration, then add it to this steering acceleration.
     *
     * @param steering the steering acceleration
     * @param scalar the scalar
     * @return this steering acceleration for chaining
     */
    SteeringAcceleration.prototype.mulAdd = function (steering, scalar) {
        this.linear.scaleAndAdd(steering.linear, scalar);
        this.angular += steering.angular * scalar;
        return this;
    };
    /** Returns the square of the magnitude of this steering acceleration. This includes the angular component. */
    SteeringAcceleration.prototype.calculateSquareMagnitude = function () {
        return this.linear.sqrLen() + this.angular * this.angular;
    };
    /** Returns the magnitude of this steering acceleration. This includes the angular component. */
    SteeringAcceleration.prototype.calculateMagnitude = function () {
        return Math.sqrt(this.calculateSquareMagnitude());
    };
    return SteeringAcceleration;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SteeringAcceleration;
//# sourceMappingURL=SteeringAcceleration.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/pawsong/gdx-ai.js/lib/steer/SteeringAcceleration.js
 ** module id = 890
 ** module chunks = 0
 **/